export enum ActionTypes {
  AUTH_LOG_IN = 'auth/AUTH_LOG_IN',
  AUTH_REQUEST = 'auth/AUTH_REQUEST',
  AUTH_ERROR = 'auth/AUTH_ERROR',
  AUTH_LOG_OUT = 'auth/AUTH_LOG_OUT',
  USER_ACTIVITY = 'auth/USER_ACTIVITY',
  GET_USER_SETTINGS_SUCCESS = 'auth/GET_USER_SETTINGS_SUCCESS',
  UPDATE_USER_SETTINGS_SUCCESS = 'auth/UPDATE_USER_SETTINGS_SUCCESS',
  GET_USER_PROFILE_SUCCESS = 'auth/GET_USER_PROFILE_SUCCESS',
}
